/**
 * Preserves specified URL parameters from the current search params
 */
export const preserveParams = (searchParams: URLSearchParams, paramsToPreserve: string[]) => {
  const newParams = new URLSearchParams();
  paramsToPreserve.forEach((param) => {
    const value = searchParams.get(param);
    if (value) newParams.set(param, value);
  });
  return newParams;
};

/**
 * Constructs a merchant-scoped navigation URL with preserved parameters
 */
export const getMerchantScopedUrl = (
  merchantSlug: string,
  path: string,
  searchParams: URLSearchParams,
  paramsToPreserve: string[] = ['from', 'to']
) => {
  const baseUrl = `/merchants/${merchantSlug}${path}`;
  const preservedParams = preserveParams(searchParams, paramsToPreserve);
  const queryString = preservedParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
